//! @ngInject
export function caregiverAppStatusService() {
  const service = {};

  /**
   * The single source of truth for "is this caregiver's app connected right now".
   *
   * This used to live on the caregivers dictionary: a socket wrote
   * `db.caregivers[id].online` on every `caregiver:online` / `caregiver:offline`
   * event, which made the dictionary a live presence store as well as a lookup
   * cache and was the main reason it could not be retired.
   *
   * The socket deltas land here now, but `getOnline` deliberately returns null:
   * deltas alone cannot answer the question. A page only learns about caregivers
   * whose state *changes* while it is open, so anyone who was already online
   * before the page loaded is indistinguishable from someone offline. Answering
   * it needs an initial snapshot alongside the deltas, and that is the part still
   * to come.
   *
   * Until then null means "unknown", and callers hide the indicator rather than
   * showing a green or red dot they cannot stand behind.
   */

  // Socket deltas, kept so the snapshot work has somewhere to merge into.
  const deltas = new Map();

  /** @returns {boolean|null} null while presence is unknown. */
  service.getOnline = function () {
    return null;
  };

  /** @returns {string|null} null while presence is unknown. */
  service.getLastSeen = function () {
    return null;
  };

  service.setOnline = function (caregiverId) {
    deltas.set(String(caregiverId), { online: true, at: new Date().toISOString() });
  };

  service.setOffline = function (caregiverId) {
    deltas.set(String(caregiverId), { online: false, at: new Date().toISOString() });
  };

  /** Only for the snapshot work that will fold these in. */
  service.peekDeltas = function () {
    return new Map(deltas);
  };

  return service;
}
